export enum BankLockStatusEnum {
  EFFECTIVE = 'Effective',
  TERMINATED = 'Terminated',
}
